var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTak2Lengeh1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 30",
    style: {
      enableBackground: "new 0 0 60 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.7,15.2H7.8c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h9.9c0.3,0,0.5,0.2,0.5,0.5S17.9,15.2,17.7,15.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "17,9.8 17,19.6 22,14.7  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3,20.2c-0.3,0-0.5-0.2-0.5-0.5V9.8c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5v9.9C44.8,20,44.6,20.2,44.3,20.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4,15.2H39.3c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5h10.1c0.3,0,0.5,0.2,0.5,0.5C49.9,15,49.7,15.2,49.4,15.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,30H0V0h60V30z M1,29h58V1H1V29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1,25.9H4V3.7h22.1V25.9z M5,25h20.2V4.7H5V25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8,30H29.3V0h30.6V30z M30.3,29h28.6V1H30.3V29z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTak2Lengeh1);
export default __webpack_public_path__ + "static/media/tak_2_lengeh_1.9698e530372f62b734b2967b10839a1d.svg";
export { ForwardRef as ReactComponent };